export default {
    app_name: "抽奖",
    //
    admin_login: "管理员登录",
    login: "登录",
    // left navs
    real_time_order_acceptance: "实时订单接收",
    number_distribution: "号码分布情况",
    total_order: "总单核对",
    order_information: "订单信息",
    winning_lottery_number: "开奖号码输入",
    number_limit: "号码限额",
    regional_time_limit: "地区限时",
    online_status: "在线情况",
    set_account_password: "设置账号密码",
    platform_settings: "平台设置",
    // settings
    platform_access_account: "平台进入账号",
    platform_access_password: "平台进入密码",
    Change_Password: "修改密码",
    old_password: "旧密码",
    new_password: "新密码",
    new_password_confirmation: "新密码确认",
    platform_data_remove: "平台数据清除",
    time: "时间",
    delete_immediately: "立即删除",
    Save_Changes: "立即提交",
    password_validation_message: "*密码必须至少包含8个字符，包括大写/小写和数字",
    // set account & password
    machine_number: "机号",
    password: "密钥",
    register: "增加",
    status: "状态",
    delete: "删除",
    online: "线上",
    offline: "离线",
    // online status
    online_machines: "在线",
    offline_machines: "不在线",
    // regional time limit
    monday: "星期一",
    tuesday: "星期二",
    wednesday: "星期三",
    thursday: "星期四",
    friday: "星期五",
    saturday: "星期六",
    sunday: "星期日",
    start: "起",
    end: "止",
    disable: "停卖",
    modify: "修改",
    // number limit
    number_digits: "数字位数",
    limit: "金额",
    save: "确定",
    special_number: "指定号码限制",
    num: "号码",
    add: "确定",
    number: "号码",
    // winning lottery number
    date: "日期",
    determine: "确定",
    search: "搜索",
    print: "打印",
    // order information
    serial_number: "出票序号",
    winning_order: "中奖订单",
    unwinning_order: "未中奖订单",
    paid_order: "中奖订单",
    unpaid_order: "未兑奖订单",
    pool: "加奖",
    amount: "金额",
    order_time: "下单时间",
    drawing_time: "开奖时间",
    region: "地区",
    winning_amount: "中奖金额",
    winning_payment_time: "兑奖时间",
    total: "合计",
    // total order
    all_machines: "全部机",
    sales: "销售额",
    commission: "提成",
    redemption_amount: "兑奖金额",
    settlement: "结算",
    commission_setting: "提成设置",
    confirm: "确认",
    general_prizes_rank1_digit4: "1st 四位数",
    general_prizes_rank2_digit4: "2nd 四位数",
    general_prizes_rank3_digit4: "3rd 四位数",
    general_prizes_rank1_digit3: "1st 三位数",
    general_prizes_rank2_digit3: "2nd 三位数",
    general_prizes_rank3_digit3: "3rd 三位数",
    general_prizes_rank1_digit2: "1st 二位数",
    general_prizes_rank2_digit2: "2nd 二位数",
    general_prizes_rank3_digit2: "3rd 二位数",
    grand_prizes_rank1_pool: "四位 pool",
    grand_prizes_rank2_pool: "三位 pool",
    grand_prizes_rank3_pool: "二位 pool",
    consolation_prizes: "安慰奖",
    total_prizes: "合计",
    // number distribution
    all: "所有",
    // real time order acceptance
    total_revenue: "总金额",
    deleted_time: "被删时间",
    // Validation messages
    Invalid_Number_Format: "无效的数字格式。"
}